import { BFF_API_ROUTES } from 'constants/apiRoutes';

import { baseRTKApi } from 'shared/api/baseApi';
import type { TLoansStatusesClientResponse } from 'shared/types/TLoansService';
import type { TStatusesV2Response } from 'shared/types/TRankingService';

export const getStatusesAPI = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    getStatuses: build.query<TLoansStatusesClientResponse, { affId?: number }>({
      query: ({ affId }) => ({
        url: BFF_API_ROUTES.getStatuses,
        method: 'GET',
        params: {
          affId,
        },
      }),
      extraOptions: { maxRetries: 0 },
    }),
    getStatusesV2: build.query<TStatusesV2Response, void>({
      query: () => ({
        url: BFF_API_ROUTES.getStatusesV2,
        method: 'GET',
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useGetStatusesQuery, useLazyGetStatusesV2Query } = getStatusesAPI;
